import { ref, reactive, type Ref } from 'vue'

export interface VideoPreviewItem {
  title: string
  created?: number
  prompt?: string
  type: 'pic' | 'three-view' | 'other'
  customTag?: string
  url: string
}

export interface VideoPreviewProps {
  videoList: VideoPreviewItem[]
  currentIndex: number
  actions?: string[]
  onClose?: () => void
  onNext?: () => void
  onPrev?: () => void
  onDownload?: () => void
}

export interface VideoPreviewState {
  videoList: VideoPreviewItem[]
  currentIndex: number
  onClose?: () => void
  onNext?: () => void
  onPrev?: () => void
  onDownload?: () => void
}

const previewState: Ref<VideoPreviewState | null> = ref(null)

/**
 * 创建视频预览的 hooks
 * @returns 预览控制方法和状态
 */
export const usePreviewVideo = () => {
  const showPreview = (props: VideoPreviewProps) => {
    // 使用 reactive 确保响应式
    previewState.value = reactive({
      videoList: props.videoList,
      currentIndex: props.currentIndex,
      onClose: props.onClose,
      onNext: props.onNext,
      onPrev: props.onPrev,
      onDownload: props.onDownload,
    })
  }

  const closePreview = () => {
    previewState.value = null
  }

  return {
    previewState,
    showPreview,
    closePreview,
  }
}
